import { ThemeProvider, StylesProvider } from "@material-ui/core/styles"
import React from "react"
import theme from "./theme"

export const wrapRootElement = ({ element }) => {
  return (
    <div id="plugin-wrapper">
      <StylesProvider>
        <ThemeProvider theme={theme}>{element}</ThemeProvider>
      </StylesProvider>
    </div>
  )
}
